var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCompletedIcon = function SvgCompletedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 45,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#91BC60",
    stroke: "#91BC60",
    d: "M22.5 4.25c10.055 0 18.25 8.195 18.25 18.25S32.555 40.75 22.5 40.75 4.25 32.555 4.25 22.5 12.445 4.25 22.5 4.25Zm9.316 11.597a1.916 1.916 0 0 0-2.55-.13l-.145.13-9.284 9.283-3.958-3.958a1.916 1.916 0 0 0-2.695 0 1.916 1.916 0 0 0-.13 2.55l.13.144 5.306 5.306a1.906 1.906 0 0 0 2.556.126l.139-.126L31.816 18.54l.006-.006a1.915 1.915 0 0 0-.006-2.688Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A6A5A3",
    d: "M53.667 22a2.667 2.667 0 1 0-5.334 0 2.667 2.667 0 0 0 5.334 0ZM71 22v-.5H51v1h20V22Z"
  })));
};
export default SvgCompletedIcon;